import { callApiWithAuthorization } from "../CallApi";
import { getUserDataFromContext } from "../Organization/organization";

export async function createContactInHubspot(loggedInUser, user) {
    let data = await getUserDataFromContext(loggedInUser);
    if (user.invitedUser) {
        data.userVerified = true;
    }
    const request = await callApiWithAuthorization("/api/v0/hubspot/createContact", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            displayName: data.displayName,
            email: data.email,
            firstName: data.firstName,
            lastName: data.lastName,
            azureId: data.azureId,
            jobTitle: data.jobTitle,
            numberOfEmployees: data.numberOfEmployees,
            domainTagSelection: localStorage.getItem("domainTagSelection") || "",
            registeredFrom: "Designer",
            phone: data.phone,
            verified: data.userVerified,
            invitedUser: user.invitedUser || false,
            companyName: data.companyName,
            isFromCopilot: data.isFromCopilot
        })
    })
    const response = await request.json();
    return response;
}

export async function updateContactInHubspot(contactId, data) {
    await callApiWithAuthorization(`/api/v0/hubspot/updateContact/${contactId}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    });
}